import { mapRecordFromServer, mapRecordsFromServer } from 'coreOld/mappers';
import { partfinitiClient } from 'coreOld/services';
import { GetManyResponse, IRequestPayload } from 'coreOld/types';
import { getFormData, getQueryString, objectKeysCamelToSnakeCase } from 'coreOld/utils';
import { IPricing } from 'partsOld/types';

export const getMany = async (
  requestPayload: IRequestPayload
): Promise<GetManyResponse<IPricing>> => {
  const { data } = await partfinitiClient.get(
    `/corporate/parts/part-prices?${getQueryString(objectKeysCamelToSnakeCase(requestPayload))}`
  );

  return mapRecordsFromServer<IPricing>(data.data, data.recordsFiltered);
};

export const upsertPrice = async (data) => {
  const formData = getFormData({
    corporate_part_price: objectKeysCamelToSnakeCase(data),
  });

  return partfinitiClient.post(`/corporate/parts/save-price`, formData);
};

export const getActiveOverlappingPrice = async (queryParams) => {
  const { data } = await partfinitiClient.get(
    `/corporate/parts/get-active-overlapping-price?${getQueryString(
      objectKeysCamelToSnakeCase(queryParams)
    )}`
  );

  return mapRecordFromServer<IPricing>(data.corporate_part_price);
};

export const removePrice = async (data) => {
  const formData = getFormData(objectKeysCamelToSnakeCase(data));

  return partfinitiClient.post(`/corporate/parts/remove-price`, formData);
};
